import useEntity from "../../hooks/useBuyerUser";
import BuyerUserDetail from "../../components/buyerUser/BuyerUserDetail/BuyerUserDetail";
import BuyerUserScoped from "../../components/buyerUser/BuyerUserDetail/BuyerUserScoped";
import BuyerUserTabs from "../../components/buyerUser/BuyerUserDetail/BuyerUserTabs";
import { useGetBuyerUserQuery } from "../../apis/BuyerUser.api";
import { PrimaryBuyerUser } from "../../types/models/BuyerUser";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const BuyerUserDetailPage = () => {

    useTitle(t`Details Buyer User`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { buyerUserId: id } = useParams();

    const { data, refetch } = useGetBuyerUserQuery(PrimaryBuyerUser.fromPath(id))
    const { deleteBuyerUser } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteBuyerUser(data, '..')
    }, [data, deleteBuyerUser])

    if (id === 'scoped') {
        return (<BuyerUserScoped/>)
    }

    return (
        <Box data-testid="BuyerUser-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <BuyerUserDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" spacing={1} sx={{ justifyContent: "center", marginTop: "2em"}}>
                    
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/BuyerUsers/update/view'
        ) ||
session.hasPermission(
            data.buyerUserScopeGroupId,
            'applications/timber/entities/BuyerUsers/update/view'
        ) ||
false) &&
                        <Button size="small" variant="outlined" data-testid="BuyerUser-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/BuyerUsers/delete/view'
        ) ||
session.hasPermission(
            data.buyerUserScopeGroupId,
            'applications/timber/entities/BuyerUsers/delete/view'
        ) ||
false) &&
                        <Button size="small" color="error" variant="outlined" data-testid="BuyerUser-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <BuyerUserTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default BuyerUserDetailPage;
